import { api } from '../api-client.config';
import { useMutation } from '@tanstack/react-query';

const deleteCompetitionMutation = (id: number) =>
  api.delete(`/competitions/${id}`);

export const useDeleteCompetitionMutation = () =>
  useMutation({
    mutationKey: ['competitions'],
    mutationFn: deleteCompetitionMutation,
  });
